/*
 * @Author: 侯鹏许(houpengxu@qq.com)
 * @Date: 2019-10-08 20:14:23
 * @LastEditors: jing
 * @LastEditTime: 2020-12-15 10:48:25
 * @Description: file content
 */
import Vue from "vue";
import Router from "vue-router";
import utils from "@/utils/utils";
import request from "@/utils/request";
import global_ from "./global.config";
import wxsdk from "@/utils/wxsdk";
import wx from "weixin-js-sdk";

import qmyxrouter from "@/views/qmyx/router"; //华发qmyx
import liverouter from "@/views/live/router"; //直播
import carrouter from "@/views/car/router"; //汽车

let routes = [
  {
    path: "/index",
    name: "index",
    meta: {
      requiresAuth: 1 //2 无需授权 1用户授权 0或者不传表示静默授权
    },
    component: () => import("./views/Index.vue")
  },
  {
    path: "/clear",
    name: "clear",
    meta: {
      requiresAuth: 2 //2 无需授权 1用户授权 0或者不传表示静默授权
    },
    component: () => import("./views/clear.vue")
  },
  {
    path: "/redirect",
    name: "redirect",
    meta: {
      requiresAuth: 2
    },
    component: () => import("./views/Redirect.vue")
  },
  {
    path: "/qywx/layout",
    name: "qywxLayout",
    meta: {
      requiresAuth: 2
    },
    component: () => import("./views/qywx/layout.vue"),
    children: [
      {
        path: "/qywx/index",
        name: "qywxIndex",
        meta: {
          title: "加载中...",
          requiresAuth: 2
        },
        component: () => import("./views/qywx/index.vue")
      }
    ]
  },
  {
    path: "*",
    name: "comingsoon",
    meta: {
      title: "敬请期待",
      requiresAuth: 2
    },
    component: () => import("./views/ComingSoon.vue")
  },
  {
    path: "/LayoutTemplate",
    name: "LayoutTemplate",
    meta: {
      title: "H5模板",
      requiresAuth: 1
    },
    component: () => import("./views/LayoutTemplate.vue"),
    children: [
      {
        path: "/wvtest",
        name: "wvtest",
        meta: {
          title: "wvtest",
          requiresAuth: 1
        },
        component: () => import("./views/wvtest.vue")
      },
      {
        path: "/LayoutTemplate/LayoutFound",
        name: "LayoutFound",
        meta: {
          title: "很多客创建页面模板",
          requiresAuth: 1
        },
        component: () => import("./views/found/LayoutFound.vue"),
        children: [
          {
            path: "/t3",
            name: "t3",
            meta: {
              title: "",
              requiresAuth: location.href.indexOf("noguide=1") > -1 ? 0 : 1
            },
            component: () => import("./views/found/t3.vue")
          },
          {
            path: "/t4",
            name: "t4",
            meta: {
              title: "",
              requiresAuth: location.href.indexOf("noguide=1") > -1 ? 0 : 1
            },
            component: () => import("./views/found/t4.vue")
          }
        ]
      },
      {
        path: "/LayoutTemplate/LayoutTutorial",
        name: "LayoutTutorial",
        meta: {
          title: "很多客使用指南模板",
          requiresAuth: 1
        },
        component: () => import("./views/tutorial/LayoutTutorial.vue"),
        children: [
          {
            path: "/t6",
            name: "t6",
            meta: {
              title: "",
              requiresAuth: location.href.indexOf("noguide=1") > -1 ? 0 : 1
            },
            component: () => import("./views/tutorial/t6.vue")
          }
        ]
      },
      {
        path: "/LayoutTemplate/LayoutVcard",
        name: "LayoutVcard",
        meta: {
          title: "很多客电子名片模板",
          requiresAuth: 1
        },
        component: () => import("./views/vcard/LayoutVcard.vue"),
        children: [
          {
            path: "/vcard",
            name: "vcard",
            meta: {
              title: "智能名片",
              requiresAuth: location.href.indexOf("noguide=1") > -1 ? 0 : 1
            },
            component: () => import("./views/vcard/vcard.vue")
          }
        ]
      },
      {
        path: "/LayoutTemplate/LayoutVcard2",
        name: "LayoutVcard2",
        meta: {
          title: "在线售楼中心电子名片模板",
          requiresAuth: 1
        },
        component: () => import("./views/vcard/LayoutVcard2.vue"),
        children: [
          {
            path: "/vcard2",
            name: "vcard2",
            meta: {
              title: "智能名片",
              requiresAuth: 1
            },
            component: () => import("./views/vcard/vcard2.vue")
          }
        ]
      },
      {
        path: "/LayoutTemplate/LayoutVcard3",
        name: "LayoutVcard3",
        meta: {
          title: "在线售楼中心电子名片模板",
          requiresAuth: 1
        },
        component: () => import("./views/vcard/vcard3/LayoutVcard3.vue"),
        children: [
          {
            path: "/vcard3/home",
            name: "home",
            meta: {
              title: "",
              requiresAuth: location.href.indexOf("noguide=1") > -1 ? 0 : 1
            },
            component: () =>
              import("./views/vcard/vcard3/components/TabHome2.vue")
          },
          {
            path: "/vcard3/tabcard2",
            name: "tabcard2",
            meta: {
              title: "智能名片",
              requiresAuth: location.href.indexOf("noguide=1") > -1 ? 0 : 1
            },
            component: () =>
              import("./views/vcard/vcard3/components/TabCard2.vue")
          },
          {
            path: "/vcard3/tabcard3",
            name: "tabcard3",
            meta: {
              title: "智能名片",
              requiresAuth: location.href.indexOf("noguide=1") > -1 ? 0 : 1
            },
            component: () =>
              import("./views/vcard/vcard3/components/TabCard3.vue")
          },
          {
            path: "/vcard3/project",
            name: "project",
            meta: {
              title: "",
              requiresAuth: location.href.indexOf("noguide=1") > -1 ? 0 : 1
            },
            component: () =>
              import("./views/vcard/vcard3/components/TabProject.vue")
          },
          {
            path: "/vcard3/location",
            name: "location",
            meta: {
              title: "",
              requiresAuth: location.href.indexOf("noguide=1") > -1 ? 0 : 1
            },
            component: () =>
              import("./views/vcard/vcard3/components/TabLocation.vue")
          },
          {
            path: "/vcard3/layout",
            name: "layout",
            meta: {
              title: "",
              requiresAuth: location.href.indexOf("noguide=1") > -1 ? 0 : 1
            },
            component: () =>
              import("./views/vcard/vcard3/components/TabLayout.vue")
          },
          {
            path: "/vcard3/calculator",
            name: "calculator",
            meta: {
              title: "",
              requiresAuth: location.href.indexOf("noguide=1") > -1 ? 0 : 1
            },
            component: () =>
              import("./views/vcard/vcard3/components/TabCalculator.vue")
          },
          {
            path: "/vcard3/video",
            name: "video",
            meta: {
              title: "",
              requiresAuth: location.href.indexOf("noguide=1") > -1 ? 0 : 1
            },
            component: () =>
              import("./views/vcard/vcard3/components/BaseVideo.vue")
          },
          {
            path: "/vcard3/videoList",
            name: "videoList",
            meta: {
              title: "",
              requiresAuth: location.href.indexOf("noguide=1") > -1 ? 0 : 1
            },
            component: () =>
              import("./views/vcard/vcard3/components/videoList.vue")
          },
          {
            path: "/vcard3/layoutDetail",
            name: "layoutDetail",
            meta: {
              title: "",
              requiresAuth: location.href.indexOf("noguide=1") > -1 ? 0 : 1
            },
            component: () =>
              import("./views/vcard/vcard3/components/LayoutDetail.vue")
          },
          {
            path: "/vcard3/status",
            name: "status",
            meta: {
              title: "",
              requiresAuth: location.href.indexOf("noguide=1") > -1 ? 0 : 1
            },
            component: () =>
              import("./views/vcard/vcard3/components/status.vue")
          },
          {
            path: "/vcard3/projectlist",
            name: "projectlist",
            meta: {
              title: "",
              requiresAuth: location.href.indexOf("noguide=1") > -1 ? 0 : 1
            },
            component: () =>
              import("./views/vcard/vcard3/components/ProjectList.vue")
          }
        ]
      },
      {
        path: "/LayoutTemplate/LayoutFound2",
        name: "LayoutFound2",
        meta: {
          title: "很多宝 创建页面模板",
          requiresAuth: 1
        },
        component: () => import("./views/found/LayoutFound2.vue"),
        children: [
          {
            path: "/t5",
            name: "t5",
            meta: {
              title: "",
              requiresAuth: 1
            },
            component: () => import("./views/found/t5.vue")
          }
        ]
      },
      {
        path: "/LayoutTemplate/LayoutFound3",
        name: "LayoutFound3",
        meta: {
          title: "楼盘信息",
          requiresAuth: 1
        },
        component: () => import("./views/found/LayoutFound3.vue"),
        children: [
          {
            path: "/t7",
            name: "t7",
            meta: {
              title: "",
              requiresAuth: 1
            },
            component: () => import("./views/found/t7.vue")
          },
          {
            path: "/t7_map",
            name: "t7_map",
            meta: {
              title: "",
              requiresAuth: 1
            },
            component: () => import("./views/found/t7_map.vue")
          },
          {
            path: "/t7_housedetail",
            name: "t7_housedetail",
            meta: {
              title: "",
              requiresAuth: 1
            },
            component: () => import("./views/found/t7_housedetail.vue")
          },
          {
            path: "/t7_photo",
            name: "t7_photo",
            meta: {
              title: "",
              requiresAuth: 1
            },
            component: () => import("./views/found/t7_photo.vue")
          },
          {
            path: "/t7_salers",
            name: "t7_salers",
            meta: {
              title: "",
              requiresAuth: 1
            },
            component: () => import("./views/found/t7_salers.vue")
          },
          {
            path: "/t7_visitors",
            name: "t7_visitors",
            meta: {
              title: "",
              requiresAuth: location.href.indexOf("noguide=1") > -1 ? 0 : 1
            },
            component: () => import("./views/found/t7_visitors.vue")
          },
          {
            path: "/t7_dtlist",
            name: "t7_dtlist",
            meta: {
              title: "",
              requiresAuth: 1
            },
            component: () => import("./views/found/t7_dtlist.vue")
          },
          {
            path: "/vrdemo/vrdemo",
            name: "vrdemo",
            meta: {
              title: "智慧VR语音带看 演示版",
              requiresAuth: 1
            },
            component: () => import("./views/vrdemo/vrdemo.vue")
          }
        ]
      },
      {
        path: "/LayoutTemplate/LayoutFound4",
        name: "LayoutFound4",
        meta: {
          title: "在线售楼中心",
          requiresAuth: location.href.indexOf("noguide=1") > -1 ? 0 : 1
        },
        component: () => import("./views/found/LayoutFound4.vue"),
        children: [
          {
            path: "/t9",
            name: "t9",
            meta: {
              title: "",
              requiresAuth: location.href.indexOf("noguide=1") > -1 ? 0 : 1
            },
            component: () => import("./views/found/t9.vue")
          },
          {
            path: "/t9_my",
            name: "t9_my",
            meta: {
              title: "",
              requiresAuth: location.href.indexOf("noguide=1") > -1 ? 0 : 1
            },
            component: () => import("./views/found/t9_my.vue")
          },
          {
            path: "/t9_zq",
            name: "t9_zq",
            meta: {
              title: "",
              requiresAuth: location.href.indexOf("noguide=1") > -1 ? 0 : 1
            },
            component: () => import("./views/found/t9_zq.vue")
          },
          {
            path: "/t9_zq_new",
            name: "t9_zq_new",
            meta: {
              title: "",
              requiresAuth: location.href.indexOf("noguide=1") > -1 ? 0 : 1
            },
            component: () => import("./views/found/t9_zq_new.vue")
          },
          {
            path: "/t9_visitors",
            name: "t9_visitors",
            meta: {
              title: "",
              requiresAuth: location.href.indexOf("noguide=1") > -1 ? 0 : 1
            },
            component: () => import("./views/found/t9_visitors.vue")
          },
          {
            path: "/t9_map",
            name: "t9_map",
            meta: {
              title: "",
              requiresAuth: location.href.indexOf("noguide=1") > -1 ? 0 : 1
            },
            component: () => import("./views/found/t9_map.vue")
          },
          {
            path: "/t9_zxrc",
            name: "t9_zxrc",
            meta: {
              title: "",
              requiresAuth: location.href.indexOf("noguide=1") > -1 ? 0 : 1
            },
            component: () => import("./views/found/t9_zxrc.vue")
          },
          {
            path: "/t9_order",
            name: "t9_order",
            meta: {
              title: "",
              requiresAuth: location.href.indexOf("noguide=1") > -1 ? 0 : 1
            },
            component: () => import("./views/found/t9_order.vue")
          },
          {
            path: "/t9_selpro",
            name: "t9_selpro",
            meta: {
              title: "",
              requiresAuth: location.href.indexOf("noguide=1") > -1 ? 0 : 1
            },
            component: () => import("./views/found/t9_selpro.vue")
          },
          {
            path: "/t9_project",
            name: "t9_project",
            meta: {
              title: "",
              requiresAuth: location.href.indexOf("noguide=1") > -1 ? 0 : 1
            },
            component: () => import("./views/found/t9_project.vue")
          },
          {
            path: "/t9_suggest",
            name: "t9_suggest",
            meta: {
              title: "",
              requiresAuth: location.href.indexOf("noguide=1") > -1 ? 0 : 1
            },
            component: () => import("./views/found/t9_suggest.vue")
          },
          {
            path: "/t9_search",
            name: "t9_search",
            meta: {
              title: "",
              requiresAuth: location.href.indexOf("noguide=1") > -1 ? 0 : 1
            },
            component: () => import("./views/found/t9_search.vue")
          },
          {
            path: "/chat_list",
            name: "chat_list",
            meta: {
              title: "",
              requiresAuth: location.href.indexOf("noguide=1") > -1 ? 0 : 1
            },
            component: () => import("./components/chat/chat_list.vue")
          }
        ]
      },
      {
        path: "/LayoutTemplate/LayoutAct",
        name: "LayoutAct",
        meta: {
          title: "如是 活动模板",
          requiresAuth: 1
        },
        component: () => import("./views/act/LayoutAct.vue"),
        children: [
          {
            path: "/coupon",
            name: "coupon",
            meta: {
              title: "优惠抢购",
              requiresAuth: 1
            },
            component: () => import("./views/act/coupon.vue")
          }
        ]
      },
      {
        path: "/huafa/sysintro",
        name: "sysintro",
        meta: {
          title: "华发股份线上售楼处",
          requiresAuth: 0
        },
        component: () => import("./views/huafa/sysintro.vue")
      },
      {
        path: "/huafa/lfintro",
        name: "lfintro",
        meta: {
          title: "蓝风线上售楼处",
          requiresAuth: 0
        },
        component: () => import("./views/huafa/lfintro.vue")
      },
      {
        path: "/huafa/intro",
        name: "intro",
        meta: {
          title: "",
          requiresAuth: 0
        },
        component: () => import("./views/huafa/intro.vue")
      },
      {
        path: "/hdk/comm_show_img",
        name: "comm_show_img",
        meta: {
          title: "",
          requiresAuth: 1
        },
        component: () => import("./views/hdk/comm_show_img.vue")
      },
      {
        path: "/hdk/comm_show_img2",
        name: "comm_show_img2",
        meta: {
          title: "发展伙伴",
          requiresAuth: 1
        },
        component: () => import("./views/hdk/comm_show_img2.vue")
      },
      {
        path: "/hdk/complaint",
        name: "complaint",
        meta: {
          title: "投诉",
          requiresAuth: 1
        },
        component: () => import("./views/hdk/complaint.vue")
      },
      {
        path: "/hdk/registration_agreement",
        name: "registration_agreement",
        meta: {
          title: "注册协议",
          requiresAuth: 1
        },
        component: () => import("./views/hdk/registration_agreement.vue")
      },
      {
        path: "/huafasubscription/register",
        name: "register",
        meta: {
          title: "华发在线认筹用户注册",
          requiresAuth: 0
        },
        component: () => import("./views/huafasubscription/register.vue")
      },
      {
        path: "/huafasubscription/register2",
        name: "register2",
        meta: {
          title: "华发在线认购用户注册",
          requiresAuth: 0
        },
        component: () => import("./views/huafasubscription/register2.vue")
      },
      {
        path: "/huafasubscription/register3",
        name: "register2",
        meta: {
          title: "华发在线认购补充信息",
          requiresAuth: 0
        },
        component: () => import("./views/huafasubscription/register3.vue")
      },
      {
        path: "/huafasubscription/housePage",
        name: "housePage",
        meta: {
          title: "华发在线认购房源信息",
          requiresAuth: 0
        },
        component: () => import("./views/huafasubscription/housePage.vue")
      },
      {
        path: "/huafasubscription/houseSure",
        name: "houseSure",
        meta: {
          title: "房源确定",
          requiresAuth: 0
        },
        component: () => import("./views/huafasubscription/houseSure.vue")
      },
      {
        path: "/huafasubscription/orderPage",
        name: "orderPage",
        meta: {
          title: "房源申请确定",
          requiresAuth: 0
        },
        component: () => import("./views/huafasubscription/orderPage.vue")
      },
      {
        path: "/huafasubscription/orderDetail",
        name: "orderDetail",
        meta: {
          title: "订单详情",
          requiresAuth: 0
        },
        component: () => import("./views/huafasubscription/orderDetail.vue")
      },
      {
        path: "/huafasubscription/payPage",
        name: "payPage",
        meta: {
          title: "在线支付",
          requiresAuth: 0
        },
        component: () => import("./views/huafasubscription/payPage.vue")
      },
      {
        path: "/huafasubscription/myPayPage",
        name: "myPayPage",
        meta: {
          title: "我的订单",
          requiresAuth: 0
        },
        component: () => import("./views/huafasubscription/myPayPage.vue")
      },
      {
        path: "/huafasubscription/payHouse",
        name: "payHousePage",
        meta: {
          title: "房源详情",
          requiresAuth: 0
        },
        component: () => import("./views/huafasubscription/payHousePage.vue")
      },
      {
        path: "/huafasubscription/PayClosePage",
        name: "PayClosePage",
        meta: {
          title: "支付成功",
          requiresAuth: 0
        },
        component: () => import("./views/huafasubscription/PayClosePage.vue")
      },
      {
        path: "/record/record",
        name: "record",
        meta: {
          title: "音频上传",
          requiresAuth: 2
        },
        component: () => import("./views/record/record.vue")
      },
      {
        path: "/aptitude-test/index",
        name: "index",
        meta: {
          title: "H5能力测试",
          requiresAuth: 2
        },
        component: () => import("./views/aptitude-test/index.vue")
      }
    ]
  }
];

if (utils.checkIsHuafa()) {
  routes = routes.concat(...qmyxrouter);
} else {
  routes.forEach(item => {
    if (item.name == "LayoutTemplate") {
      item.children = item.children.concat(...liverouter);
      item.children = item.children.concat(...carrouter);
    }
  });
}

Vue.use(Router);
const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: routes,
  scrollBehavior(to, from, savedPosition) {
    console.log("scrollbehavior: ", to, from, savedPosition);
    if (to.name === "my-customer") {
      return {};
    }
    return savedPosition;
  }
});

// 全局路由守卫
router.beforeEach((to, from, next) => {
  // to: Route: 即将要进入的目标 路由对象
  // from: Route: 当前导航正要离开的路由
  // next: Function: 一定要调用该方法来 resolve 这个钩子。执行效果依赖 next 方法的调用参数。

  // 是否有debug=true
  if (to.query.debug && to.query.debug == "true") {
    global_.isDebug = true;
  }

  //初始化Cookies(openid,passport...)
  utils.initCookies(to.query);

  //设置页面title
  if (to.meta.title) {
    document.title = to.meta.title;
  }

  //判断授权方式
  // if (!to.query.j || to.name == 'redirect') {
  if (location.href.indexOf("/h5/qywx/") > -1) {
    // 企业微信下
    next();
  } else {
    request
      .get(global_.API_URL, {
        action: "getConfig"
      })
      .then(response => {
        console.log(response);
        global_.OAUTH_URL = response.obj.auth_url;
        global_.APPID = response.obj.appid;
        global_.SHARE_API = response.obj.share_api;
        global_.OAUTH_IMG = response.obj.app_qrurl;
        //微信sdk初始化
        global_.SHARE_CALLBACK_OK = function() {};

        // //华发小程序返回处理
        // if(to.query.j) {
        //   if (utils.checkIsHuafa()) {
        //     utils.getIsInMiniProgram(myVue.$store.state.isInMiniProgram).then(isMp => {
        //       if (isMp) {
        //         window.addEventListener("popstate", event => {
        //           wx.miniProgram.navigateBack();
        //         });
        //       }
        //     })
        //   }
        // }

        if (to.meta.requiresAuth && to.meta.requiresAuth === 2) {
          next();
        } else if (to.query.from && to.query.from === "h5") {
          next();
        } else if (to.query.from && to.query.from === "sysintro") {
          //从售楼中心集合跳转过来的页面走静默授权
          utils.needsAuth(0, () => {
            wxsdk.init(() => next());
          });
        } else if (to.query.authtype && to.query.authtype === "silence") {
          //静默授权
          utils.needsAuth(0, () => {
            wxsdk.init(() => next());
          });
        } else if (utils.checkIsJxwk() || utils.checkIsSdty()) {
          //江西万科,天纵时代天樾 还用通用的模式，如果是小程序审核中小程序打开连接就会加noguide=1
          utils.needsAuth(to.meta.requiresAuth, () => {
            wxsdk.init(() => next());
          });
        } else if (utils.checkIsHuafa()) {
          utils
            .getIsInMiniProgram(myVue.$store.state.isInMiniProgram)
            .then(isMp => {
              if (isMp) {
                //静默授权
                utils.needsAuth(0, () => {
                  wxsdk.init(() => next());
                });
              } else {
                utils.needsAuth(to.meta.requiresAuth, () => {
                  wxsdk.init(() => next());
                });
              }
            });
        } else if (utils.checkIsZxslzx()) {
          // 在线售楼中心，小程序版打开也走静默授权
          utils
            .getIsInMiniProgram(myVue.$store.state.isInMiniProgram)
            .then(isMp => {
              if (isMp) {
                //静默授权
                utils.needsAuth(0, () => {
                  wxsdk.init(() => next());
                });
              } else {
                utils.needsAuth(to.meta.requiresAuth, () => {
                  wxsdk.init(() => next());
                });
              }
            });
        } else {
          utils.needsAuth(to.meta.requiresAuth, () => {
            wxsdk.init(() => next());
          });
        }
      });
  }
  // }
});
console.log("router", router);
export default router;
